/**
 * TABS
 * author: @matej.kamenec
 */

function Tabs(element) {
    this.tabsElement = element;
    this.init();
}

Tabs.prototype.init = function () {
	this.renderNavigation(this.getTabs());
	this.listener();	

	if(this.checkHash()) {
		var hash = this.getHash();		
		for(var i = 0; i < this.tabNames.length; i++) {
			if(this.tabNames[i].Id == hash) {
				this.scrollToTabs();
				this.showTab(this.tabNames[i]);
			}
		}		
	}else {
		this.showTab(this.tabNames[0]);
	}
};

Tabs.prototype.checkHash = function() {
	var hashExists = false;

	if(window.location.hash) {
        if (window.location.hash.indexOf('#tab=') == 1)
            hashExists = true;
        else if (window.location.hash.indexOf('#tab=') != -1)
            hashExists = true;
    }

    return hashExists;
};

Tabs.prototype.getHash = function() {
	var anchor = '';
	var hashExists = this.checkHash();

	if(hashExists) {
		anchor = window.location.href.split('\#')[1];
		if (anchor == undefined)
			anchor = '';
		else
			anchor = anchor.split('\=')[1];
	}

	return anchor;
};

Tabs.prototype.getTabs = function () {
	var tabs = this.tabsElement.find(' > div');
	var tabNames = [];

	tabs.each(function(i){
		var tab = $(this);
		var obj = {};
		obj.Title = tab.data('title');
		obj.Id = tab.attr('id');
		tabNames.push(obj);
	});

	this.tabNames = tabNames;

	return tabNames;
}

Tabs.prototype.getTab = function (i) {
	return this.tabNames[i];
};

Tabs.prototype.showTab = function (object) {
	this.tabsElement.find('ul li').removeClass('active');
	this.tabsElement.find(' > div').hide('blind', 400, function(){
		setTimeout(function(){
			$('.' + object.Id).addClass('active');
			$('#' + object.Id).show('blind', 400);	
		}, 100);
		
	});	
};

Tabs.prototype.renderNavigation = function (items) {
	var html = '<ul>';

	for(var i = 0; i < items.length; i++) {
		html += '<li class="' + items[i].Id + '"><a href="#' + items[i].Id + '">' + items[i].Title + '</a></li>';
	}

	html+= '</ul>';
	this.tabsElement.prepend(html);
}

Tabs.prototype.listener = function () {
	var _this = this;

	$(document).on('click', this.tabsElement.selector + ' ul > li', function(event){
		event.preventDefault();
		var tab = $(this);

		_this.showTab(_this.getTab(tab.index()));
		window.location.hash = 'tab=' + tab.attr('class');
	});
};

Tabs.prototype.scrollToTabs = function() {
	var _this = this;
	$('html, body').animate({
		scrollTop: _this.tabsElement.offset().top - 40
	}, 400);
};